import Modal from '@material-ui/core/Modal'
import { Grid, Link, makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modal: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    width: 'fit-content',
    position: 'relative',
    margin: '0 auto',
    backgroundColor: 'white',
    padding: '10px 10px 10px 20px',
    borderRadius: '10px',
    fontWeight: '600',
  },
}))

const CustomModal = ({ children, handleClose, open }) => {
  const classes = useStyles()
  return (
    <Modal open={open} onClose={handleClose} className={classes.modal}>
      <div className={classes.container}>
        <span style={{ float: 'right' }} onClick={handleClose}>
          X
        </span>
        {children}
      </div>
    </Modal>
  )
}

export default CustomModal
